import { useState, useEffect } from "react";

interface ScaleInputProps {
  value: number;
  onChange: Function;
}

export default function ScaleInput({ value, onChange }: ScaleInputProps) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <input
      type="number"
      min="0.01"
      step="0.01"
      value={inputValue}
      onChange={(e) => {
        const newValue = e.target.valueAsNumber;
        setInputValue(newValue);

        if (Number.isFinite(newValue) && newValue > 0) {
          onChange(newValue);
        }
      }}
    />
  );
}
